/** Contract visit (included in AMC) vs extra visit (may be invoiced separately). */
export enum AmcVisitKind {
  CONTRACT = "CONTRACT",
  EXTRA = "EXTRA",
}

export const amcVisitKindLabelMap: Record<AmcVisitKind, string> = {
  [AmcVisitKind.CONTRACT]: "Contract visit",
  [AmcVisitKind.EXTRA]: "Extra visit",
};

/** AMC visit lifecycle. */
export enum AmcVisitStatus {
  PLANNED = "PLANNED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  MISSED = "MISSED",
  CANCELLED = "CANCELLED",
}

export const amcVisitStatusMap = {
  [AmcVisitStatus.PLANNED]: {
    label: "Planned",
    color: "info",
  },
  [AmcVisitStatus.IN_PROGRESS]: {
    label: "In Progress",
    color: "warning",
  },
  [AmcVisitStatus.COMPLETED]: {
    label: "Completed",
    color: "success",
  },
  [AmcVisitStatus.MISSED]: {
    label: "Missed",
    color: "secondary",
  },
  [AmcVisitStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
} as const;
